import {fetchTooltipMetadata} from "../login/ClientCache";
import {mapParameters} from "../actions/BaseDispatcher";
import {getFieldParentDetail} from "./Metadata";
import * as NamaURLS from "../constants/NamaURLS";
import {ajaxJSON, getFirstNotEmptyObj, isEmptyOrNull} from "./NamaCommon";
import * as trans from "./Translator";
import {join} from "./CollectionsUtility";
import {EditScreenGrid} from "../views/edit/EditScreenGrid";
import {NamaGridWidget} from "../grid/NamaGridWidget";

function getTooltip(joinedTooltips, tooltipMetadata) {
    if (isEmptyOrNull(joinedTooltips))
        return null;
    return joinedTooltips.map(r => tooltipMetadata.fieldTooltips[r.index]);
}

function fetchFieldTooltipInfo(tooltipMetadata, entityType, id) {
    let fieldTooltips = [];
    let fieldsTooltipById = tooltipMetadata.fieldsTooltips[entityType + "#" + id];
    if (fieldsTooltipById)
        fieldTooltips = fieldsTooltipById.list || [];
    let defaultTooltips = tooltipMetadata.defaultTooltips[id] || [];
    let joinedTooltips = join(fieldTooltips, defaultTooltips);
    return getTooltip(joinedTooltips, tooltipMetadata);
}

/**
 * @type kendo.ui.Tooltip
 */
let kendoTooltip;
export function showNotification(toolTipContent) {
    if (kendoTooltip)
        kendoTooltip.destroy();
    let tooltip = $(`<span class = "fieldTooltip"></span>`);
    tooltip.kendoTooltip({
        content: (e) => {
            return toolTipContent;
        },
    });
    kendoTooltip = tooltip.data("kendoTooltip");
    kendoTooltip.show();
}

function hideTooltip() {
    if (kendoTooltip) {
        kendoTooltip.hide();
        kendoTooltip.destroy();
    }
}

let lastFieldId, lastLineNumber, lastGridId;

export function showTooltip(entityType, fieldId, lineNumber, presenter, gridId, automaticTooltipsOnly) {
    if (kendoTooltip && kendoTooltip.popup.visible() && !automaticTooltipsOnly && (fieldId === lastFieldId && lastGridId === gridId && lastLineNumber === lineNumber)) {
        hideTooltip();
        return;
    }
    lastFieldId = fieldId;
    lastGridId = gridId;
    lastLineNumber = lineNumber;
    let tooltipMetadata = fetchTooltipMetadata();
    if (presenter instanceof NamaGridWidget)
        presenter = presenter.owner;
    /**
     *
     * @type [namaTypes.FieldTooltipInfo]
     */
    let fieldTooltipInfo = fetchFieldTooltipInfo(tooltipMetadata, entityType, fieldId);
    if (gridId && !fieldTooltipInfo)
        fieldTooltipInfo = fetchFieldTooltipInfo(tooltipMetadata, entityType, gridId);
    if (!fieldTooltipInfo)
        return;
    if (automaticTooltipsOnly)
        fieldTooltipInfo = fieldTooltipInfo.filter(i => i.automaticTooltip);
    let contextFields = mapParameters(fieldId, lineNumber, fieldTooltipInfo, presenter);
    /**
     *
     * @type {namaTypes.GUIRunTooltipReq}
     */
    let request = {
        lineNumber: lineNumber,
        parameters: contextFields,
        requester: fieldId,
        requesterParentDetail: getFieldParentDetail(fieldId, presenter.metaData),
        targetEntityType: entityType,
        tooltipInfo: fieldTooltipInfo
    };
    ajaxJSON(NamaURLS.RunTooltip, {
        request: JSON.stringify(request)
    }, (result) => {
        let toolTipContent = "";
        if (trans.isArabic())
            toolTipContent = getFirstNotEmptyObj(result.data.arabicText, result.data.englishText);
        else
            toolTipContent = getFirstNotEmptyObj(result.data.englishText, result.data.arabicText);
        showNotification(toolTipContent);
    });

}